<template>
  <Client :categories="categoryList">
    <template #app-main>
      <div class="app-container">
          <el-row :gutter="24" type="flex" justify="center">
              <el-col :sm="16" :sx="24">
                <div id='div-gpt-ad-1744610612647-0' style='min-width: 320px; min-height: 250px;'>
                  <component :is="'script'">
                   googletag.cmd.push(function() {
                        googletag.defineSlot('/23292652075/clashhorizon.top1', [300, 250], 'div-gpt-ad-1744610612647-0').addService(googletag.pubads());
                        googletag.pubads().enableSingleRequest();
                        googletag.pubads().collapseEmptyDivs();
                        googletag.enableServices();
                        });
                     googletag.cmd.push(function() { googletag.display('div-gpt-ad-1744610612647-0'); });
                  </component>
                </div>
              </el-col>
          </el-row>
          <el-row :gutter="24" type="flex" justify="center" v-if="searchOpen">
          <el-col :sm="16" :sx="24">
            <search class="search" />
          </el-col>
        </el-row>
         <el-row :gutter="24" type="flex" justify="center">
            <el-col :sm="16" :sx="24">
              <div id='div-gpt-ad-1744610660685-0' style='min-width: 320px; min-height: 250px;'>
                <component :is="'script'">
                 googletag.cmd.push(function() {
                      googletag.defineSlot('/23292652075/clashhorizon.top2', [300, 250], 'div-gpt-ad-1744610660685-0').addService(googletag.pubads());
                      googletag.pubads().enableSingleRequest();
                      googletag.pubads().collapseEmptyDivs();
                      googletag.enableServices();
                      });
                   googletag.cmd.push(function() { googletag.display('div-gpt-ad-1744610660685-0'); });
                </component>
              </div>
            </el-col>
        </el-row>
       <el-row :gutter="5" justify="center">
         <el-col :sm="16" :sx="24">
           <Banner class="search" />
         </el-col>
        <el-col :sm="16" :sx="24">
        <div v-loading="loading" element-loading-text="Loading......">
          <div class="categorysite-card" v-for="categorySite in siteList" :key="categorySite.id">
            <el-button class="categorytitle-label"
               :id="'category-' + categorySite.id"
               :ref="'category-' + categorySite.id"
             >
               <span>{{
                 categorySite.categoryName
               }}</span>
               </el-button>
               <el-button type="text" @click="handleCateMore(categorySite.id)" class="categorytitle-label-more"
                 :id="'category-' + categorySite.id"
                 :ref="'category-' + categorySite.id"
               >
               <span>more</span>
               </el-button>
             <div class="sitelist-card"  v-if="categorySite.id !== '150725316141101004' && categorySite.id !== '150725316141101037' && device !== 'mobile'">
            <el-row :gutter="5">
              <el-col
                :lg="24 / showCount"
                :md="24 / 2"
                :sm="24 / 2"
                :xs="12"
                :span="24"
                class="mb15"
                v-for="site in categorySite.sites.slice(0,18)"
                :key="site.id"
              >
                <SiteCard :site="site" :disabled-tip="false" />
              </el-col>
            </el-row>
            </div>
             <div class="sitelist-card"  v-if="categorySite.id !== '150725316141101004' && categorySite.id !== '150725316141101037' && device === 'mobile'">
               <div v-for="(site, siteIndex) in categorySite.sites.slice(0,10)" :key="site.id" class="image-group">
                  <!-- 大图：group，当存在时 -->
                 <div v-if="siteIndex===0" class="main-image">
                    <SiteCardBig :site="site" :disabled-tip="false" />
                 </div>
                  <!-- 下方的小图 -->
                 <div v-if="siteIndex===0" class="sub-images">
                    <div v-for="(sitesub) in categorySite.sites.slice(1,5)" :key="sitesub.id"  class="grid-item">
                      <SiteCard :site="sitesub" :disabled-tip="false" />
                    </div>
                  </div>
                   <div v-if="siteIndex===5" class="main-image">
                      <SiteCardBig :site="site" :disabled-tip="false" />
                   </div>
                    <!-- 下方的小图 -->
                   <div v-if="siteIndex===5" class="sub-images">
                      <div v-for="(sitesub) in categorySite.sites.slice(6,10)" :key="sitesub.id"  class="grid-item">
                        <SiteCard :site="sitesub" :disabled-tip="false" />
                      </div>
                    </div>
               </div>
              </div>
            <div class="sitelist-card"  v-if="categorySite.id === '150725316141101004' || categorySite.id === '150725316141101037'">
              <Vue3Marquee class="sitelistMarquee"  :duration="50" :pause-on-hover="true" @on-pause="playState = 'paused'"   @on-resume="playState = 'playing'">
                   <div
                        v-for="site in categorySite.sites.slice(0,10)"
                       :key="site.id"
                   >
                          <router-link :to="'/detail/get/' + site.id" target="_blank">
                            <div class="card-bg">
                             <el-badge :value="site.clickCount" max="5000" :offset="[-30, 15]"  color="green">
                                 <el-image
                                   fit="cover"
                                   class="carousel-item-image"
                                   :src="getPictureShowUrl(site.sitePath)"
                                 ></el-image>
                                 </el-badge>
                                 <div class="carousel-title">
                                   <span class="article-title">{{ site.siteName }}</span>
                                 </div>
                                 </div>
                               </router-link>

                      </div>
               </Vue3Marquee>
              </div>
          </div>
        </div>
         </el-col>
     </el-row>
      </div>
    </template>
  </Client>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import Client from '@/layout/client'
import SiteCardBig from '@/components/SiteCardBig'
import SiteCard from '@/components/SiteCard'
import { Vue3Marquee } from 'vue3-marquee'
import { openSite } from '@/utils/geshanzsq'
import Banner from '@/components/Banner'
import Search from '@/layout/client/components/Search'
/** 获取所有的游戏
 * import { categorySiteList } from '@/api/client/nav'
 */
import { categorySiteListByDomain } from '@/api/client/nav'
import { siteDomain } from '@/config/setting.config'
const store = useStore()
const device = computed(() => store.getters['app/device'])
const searchOpen = computed(() => store.getters['settings/searchOpen'])
const showCount = computed(() => store.getters['settings/showCount'])
const loading = ref(true)
const categoryList = ref([])
const siteList = ref([])
const playState = ref('playing')
/**
 * 获取数据
 */
async function getData() {
  loading.value = true
  const {
    data: { sites }
  } = await categorySiteListByDomain(siteDomain)
  categoryList.value = sites
  siteList.value = sites
  loading.value = false
}

getData()
/**
 * 网站卡片点击事件
 */
function handleCateMore(id) {
  if (!id) {
    return
  }
  openSite('/cate/get/' + id)
}
</script>
<style lang="scss" scoped>
.modal {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  z-index: 20000; /* 这个值需要高于其他元素的z-index值 */
}
.categorysite-card {

  cursor: pointer;
  border: none;
  border:1px  black;
  margin-top:5px;
  border-radius: 15px;
  background: #223884;
  background: rgba(222,222,221,0.6);
  padding-left: 5px;
  padding-top: 1px;
  color: #fff;
  .categorytitle-label {
        font-weight: 700;
        padding: 10px 1rem;
        border-radius: 5rem;
        background: linear-gradient(141deg, #1E50FF 20%, #BD00FF 80%);
        width: fit-content;
        margin-bottom: 0rem;
        margin-top: 5px;
        color: #fff;
        border-radius: 1rem;
        float: left;
    }
    .categorytitle-label-more {
          font-weight: 700;
          padding: 10px 1rem;
          border-radius: 5rem;
          background: linear-gradient(141deg, #1E50FF 20%, #BD00FF 80%);
          width: fit-content;
          margin-bottom: 0rem;
          margin-top: 5px;
          margin-right:10px;
          color: #fff;
          border-radius: 1rem;
          float: right;
      }
  .sitelist-card {
    width:98%;
    margin-top: 50px;
    .image-group{
    width:100%;
     text-align: center;
     .main-image {
          overflow: hidden;
          text-align: center;
        }
        .sub-images {
           display: grid;
           grid-template-columns: repeat(2, 1fr);
         }
         .grid-item {
           text-align: center;
           width:170px;
         }
      }
     .sitelistMarquee
     {
        border-radius:15px;
        .card-bg{
         height: 300px;
         width: 100%;
         display: flex;
         justify-content: center;
         border-radius: 20px;
         .carousel-item-image {
           background: rgba(0, 0, 0, 0.5);
           display: block;
           height: 300px;
           width: 300px;
           overflow: hidden;
           border-radius: 20px;
        }
        .item {
          margin-top: 10px;
          margin-right: 30px;
        }
      }
    }
  }
.carousel-title {
    cursor: pointer;
    position: absolute;
    z-index: 10;
    bottom: 0px;
    height: 40px;
    width: 300px;
    line-height: 40px;
    text-align: center;
    margin-top: 10px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0px 0px 20px 20px;
     .little{
         margin-top:5px;
         width: 1.5em;
         height: 1.5em;
     }
  }
}
.categorysite-card-mobile {

  cursor: pointer;
  border: none;
  border:1px  black;
  margin-top:5px;
  border-radius: 15px;
  background: #223884;
  background: rgba(222,222,221,0.6);
  padding-left: 5px;
  padding-top: 1px;
  color: #fff;
  width:370px;
.categorytitle-label {
      font-weight: 700;
      padding: 10px 1rem;
      border-radius: 5rem;
      background: linear-gradient(141deg, #1E50FF 20%, #BD00FF 80%);
      width: fit-content;
      margin-bottom: 0rem;
      margin-top: 5px;
      color: #fff;
      border-radius: 1rem;
      float: left;
  }
  .categorytitle-label-more {
        font-weight: 700;
        padding: 10px 1rem;
        border-radius: 5rem;
        background: linear-gradient(141deg, #1E50FF 20%, #BD00FF 80%);
        width: fit-content;
        margin-bottom: 0rem;
        margin-top: 5px;
        margin-right:10px;
        color: #fff;
        border-radius: 1rem;
        float: right;
    }
  .sitelist-card {
  margin-top: 50px;
  width:98%;
  }

}
</style>
